import React from "react";
import styles from "./seperator.module.css";
import cn from "classnames";

type SeperatorProps = {
  direction?: "horizontal" | "vertical";
};

export const Seperator = ({ direction = "horizontal" }: SeperatorProps) => {
  return <div className={cn(styles.seperator, styles[direction])} />;
};
